/* eslint-disable react/no-danger */
import React from 'react';
import { Alert, Col, Row, } from 'react-bootstrap';
import { FaCircleCheck, FaCircleExclamation, FaTriangleExclamation } from 'react-icons/fa6';

export default function Messages({ items, clear }) {
  return items?.length > 0 && (
    <Row className="mt-1">
      <Col className="messages">
        {items.filter((el) => !el.toast).map((item) => (
          <Alert variant={item.type} key={item.id} dismissible onClose={() => clear(item.id)}>
            {item.type === 'danger' && <FaCircleExclamation className="me-2" />}
            {item.type === 'warning' && <FaTriangleExclamation className="me-2" />}
            {item.type === 'success' && <FaCircleCheck className="me-2" />}
            <span dangerouslySetInnerHTML={{ __html: item.message }} />
          </Alert>
        ))}
      </Col>
    </Row>
  );
}
